module.exports = __webpack_public_path__ + "img/feature_2.eaee1805.svg";